<template>
    <div>
        <v-dialog v-model="open" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title v-if="meter_id">Edit device</v-toolbar-title>
                    <v-toolbar-title v-else>Add device</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline"> </v-card-title>
                <v-card-text>
                    <v-form ref="form" class="text-center">
                        <v-card>
                            <v-toolbar outlined flat v-if="!meter_id">
                                <v-row>
                                    <v-col>
                                        <v-text-field :disabled="valid" v-model="gateway.id" label="Name" outlined flat dense solo hide-details></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field :disabled="valid" v-model="gateway.key" label="Key" outlined flat dense solo hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-spacer></v-spacer>
                                <v-btn color="accent" small :loading="loading" @click="verifyGateway">
                                    <v-icon>mdi-check</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-title  v-if="meter != null && !reg">Please fill all the fields with the corresponding data</v-card-title>
                            <v-card-text v-if="meter != null && !reg" class="pb-8"> 
                                <v-row>
                                    <v-col class="text-left">
                                        <v-row cols="4" class="text-left mx-auto mt-3 mb-auto">Name</v-row>
                                        <v-text-field v-model="data_meter.circuit" label="Device name" outlined flat dense solo hide-details></v-text-field>
                                    </v-col>
                                    <v-col class="text-left">
                                        <v-row cols="4" class="text-left mx-auto mt-3 mb-auto">Installed capacity</v-row>
                                        <v-text-field v-model="data_meter.capacity" label="Watts" type="number" outlined flat dense solo hide-details></v-text-field>
                                    </v-col>
                                    <v-col class="text-left">
                                        <v-row cols="4" class="text-left mx-auto mt-3 mb-auto">Fare</v-row>
                                        <v-text-field v-model="data_meter.fare" label="Fare" type="number" outlined flat dense solo hide-details></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="text-left mx-auto mt-3 mb-n3">Location</v-row>
                                <v-row>
                                    <v-col class="text-left" cols="4">
                                        <v-text-field v-model="data_meter.latitude" label="Latitude" type="number" outlined flat dense solo hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-text-field v-model="data_meter.longitude" label="Longitude" type="number" outlined flat dense solo hide-details></v-text-field>
                                    </v-col>
                                    <v-col cols="4">
                                        <v-btn small class="my-1 green--text" @click="retrieveLoc">Retrieve location</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row v-if="clicked && msg">
                                    <p class="red--text mx-3 font-italic shake">{{ msg }}</p>
                                </v-row>
                                <v-card>
                                <v-row>
                                    <v-col id="map">
                                    </v-col>
                                </v-row>
                                </v-card>
                            </v-card-text>
                            <v-card-text v-else class="py-16">
                                <v-icon large>mdi-playlist-check</v-icon>
                                <p>Validate device to add it</p>
                            </v-card-text>
                        </v-card>  
                    </v-form>  
                </v-card-text>
                <v-card-actions class="mr-4 mt-n5">
                    <v-spacer></v-spacer>
                    <v-btn color="accent" 
                        small 
                        :disabled="meter == null || data_meter.circuit === null || data_meter.latitude == null || data_meter.longitude == null || data_meter.capacity == null || data_meter.fare == null
                        || data_meter.circuit === '' || data_meter.latitude == '' || data_meter.longitude == '' || data_meter.capacity == '' || data_meter.fare == ''" 
                        class="ml-5" 
                        @click="save" 
                        :loading="processing"
                        >Save
                    </v-btn>
                    <v-btn v-if="meter_id" color="danger" class="white--text ml-5" small text @click="popUpDelete">Delete</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="error.active" :timeout="3000">
            {{ error.message }}
            <template v-slot:action="{ attrs }">
                <v-btn color="error" text v-bind="attrs" @click="error.active = false">Close</v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="openup">
            {{exists}}
            <template v-slot:action="{ attrs }">
                <v-btn color="error" text v-bind="attrs" @click="openup = false">Close</v-btn>
            </template>
        </v-snackbar>
         <v-snackbar v-model="success" :timeout="3000">
            Device saved successfully
            <template v-slot:action="{ attrs }">
                <v-btn color="error" text v-bind="attrs" @click="success = false">Close</v-btn>
            </template>
        </v-snackbar>
        <formDelete :openPopUp="openPopUp" @close="actionCloseNew" :meter_id="data_meter.circuit"/>
        <formConfirmation :openConfirm="openConfirm" @close="actionCloseNew" :meter_id="data_meter.circuit" @saveFunction="save"/>
    </div>
</template>

<script>
import { Gateway } from '../api'
import { mapActions, mapGetters, mapState } from 'vuex'
import formDelete from './formDelete'
import formConfirmation from './formConfirmation'
export default {
    name: 'formMeters',
    props: ['open', 'meter_id'],
    computed:{
        ...mapGetters({ getMeter: 'meters/getMeter'}),
        ...mapState({
            meters: state => state.meters.meters,
        })
    },
    components: { formDelete, formConfirmation },
    data() {
        return {
            gateway: { id: '', key: '' },
            loading: false,
            meter: null,
            data_meter: { circuit: null, longitude: null, latitude: null, capacity: null, fare: null },
            error: { message: '', active: false },
            center: { lat: null, lng: null },
            openPopUp: false,
            openConfirm: false,
            meter_name: '',
            msg: '',
            openup: false,
            exists:'',
            reg: false,
            clicked: false,
            processing: false,
            success: false,
            valid: false
        }
    },
    methods: {
        ...mapActions({ 
            addMeters: 'meters/addMeters',
            editMeter: 'meters/editMeter',
            deleteMeter: 'meters/deleteMeter',
            checkMeter: 'meters/checkMeter'
        }),
        async verifyGateway(){
            this.clicked = false
            if(!this.gateway.id || !this.gateway.key) {
                this.error.message = 'Enter gateway and key'
                this.error.active = true
                this.loading = false
                return
            }
            try {
                let { data } = await Gateway.get({ id: this.gateway.id, key: this.gateway.key })
                for (let index = 0; index < this.meters.length; index++) {
                    const element = this.meters[index].gateway.id;
                    if(this.gateway.id === element){
                        this.exists = "Gateway registered"
                        this.openup = true
                        this.reg = true
                        return
                    }
                }
                this.reg = false
                this.meter = data[0]
            } catch (error) {
                if(error.response.status == 400){
                    this.error.message = 'Invalid key'
                    this.error.active = true
                }else if(error.response.status == 404){
                    this.error.message = 'Gateway not found'
                    this.error.active = true
                }
            }
            this.loading = false
            this.valid = true
        },
        async openSave(){
            this.openConfirm = true
        },
        async save(){
            this.processing = true
            if(!this.meter_id){
                await this.addMeters({
                    meters:[{ ...this.meter, ...this.data_meter }],
                    gateway: this.gateway
                })
            }else{
                await this.editMeter({  ...this.meter, ...this.data_meter, ...this.center, gateway: this.gateway })
            }
            await this.$emit('update')
            await this.sleep(2000).then(() => { this.processing = false; });
            this.sleep(1000).then(() => { this.close(); });
            this.success = true
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        close(){
            this.reset()
            this.$emit('close')
        },
        reset(){
            this.clicked = false
            this.valid = false
            this.gateway = { id: '', key: '' }
            this.data_meter = { circuit: '', longitude: null, latitude: null, capacity: null, fare: null }
            this.meter = null
        },
        popUpDelete() {
            this.openPopUp = true
            this.meter_name = this.data_meter.circuit
        },
        popUpConfirm() {
            this.openConfirm = true
            this.meter_name = this.data_meter.circuit
        },
        async actionCloseNew(){
            this.openPopUp = false
            this.openConfirm = false
            await this.updateData()
        },
        async retrieveLoc(){
            this.clicked = true
            let gw = await Gateway.get({ id: this.gateway.id, key: this.gateway.key })
            let lat = gw.data[0].location.lat
            let lon = gw.data[0].location.lon
            if(lat && lon){
                this.data_meter.latitude = gw.data[0].location.lat
                this.data_meter.longitude = gw.data[0].location.lon
                this.msg = ''
            }else{
                this.msg = "Data not registered, please type it"
            }
        },
        async updateData(){
            await this.$emit('update')
            this.close()
        },
    },
    watch:{
        meter_id(){
            if(this.meter_id){
                let meter = this.getMeter(this.meter_id)
                this.meter = { name: meter.name, key: meter.key, nlines: meter.nlines }
                this.data_meter = { circuit: meter.circuit, latitude: meter.location.latitude, longitude: meter.location.longitude, capacity: meter.capacity,  fare: meter.fare }
                this.gateway = meter.gateway
                this.center = { lat: meter.location.latitude, lng: meter.location.longitude }
            }
        },
    },
}
</script>

<style scoped>
#map {
    display: contents;
    height: 300px;
}
</style>